<template>
  <div class="end-kanban-board">
    <!-- 分拣看板 -->
    <el-card class="metric-card" shadow="hover">
      <div class="flx-between label-title">
        <div>分拣看板 Painel de Triagem</div>
        <el-radio-group v-model="queryForm.dataType" size="mini" @change="changeDataType">
          <el-radio-button label="HUB1" />
          <el-radio-button label="HUB2" />
        </el-radio-group>
        <div style="font-weight: normal">
          数据更新时间 Horário da Última Atualização de Dados: {{ updateTime || '--' }}
        </div>
      </div>
      <!-- 分拣看板 查询 -->
      <div class="flex-start" style="font-size: 14px; font-weight: bold; margin-top: 10px">
        <!-- 大区 -->
        <div class="flex-start">
          <span>大区 Região</span>
          <el-select
            v-model="queryForm.areaNameList"
            :placeholder="$t('placeOrder.pleaseChoose')"
            clearable
            collapse-tags
            filterable
            multiple
            size="small"
            @change="changeRegion"
          >
            <el-option
              v-for="item in regionList"
              :key="item.regionId"
              :label="item.regionName"
              :value="item.regionName"
            />
          </el-select>
        </div>
        <!-- 州 -->
        <div class="flex-start">
          <span>州 Estado</span>
          <el-select
            v-model="queryForm.stateList"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            clearable
            filterable
            multiple
            size="small"
            @change="changeStateList"
          >
            <el-option
              v-for="item in stateList"
              :key="item.state"
              :label="item.state"
              :value="item.state"
            />
          </el-select>
        </div>
        <!-- 转运中心 -->
        <div class="flex-start">
          <span>转运中心 Hub</span>
          <el-select
            v-model="queryForm.departmentList"
            :placeholder="$t('GlobalSetObj.all')"
            clearable
            collapse-tags
            filterable
            multiple
            size="small"
          >
            <el-option
              v-for="item in transferCenterList"
              :key="item.siteId"
              :label="item.siteName"
              :value="item.siteName"
            />
          </el-select>
        </div>
        <div class="filter-section">
          <el-date-picker
            v-model="timeValue"
            :picker-options="pickerOptions"
            align="right"
            end-placeholder="结束日期"
            range-separator="~"
            size="small"
            start-placeholder="开始日期"
            style="width: 280px; margin-right: 10px"
            type="daterange"
            unlink-panels
            value-format="yyyy-MM-dd"
          />
          <el-button
            icon="el-icon-search" size="small" type="primary"
            @click="getSearch"
          />
        </div>
      </div>
    </el-card>
    <!-- 数据监控 -->
    <el-row :gutter="10">
      <el-col :span="14">
        <el-card class="metric-card" shadow="hover">
          <!-- 到发件数据监控 -->
          <div class="label-title">到发件数据监控 Monitoramento de Dados de Chegada e Envio</div>
          <div class="flx-between" style="margin: 5px 0 10px 0">
            <div>
              <div>应到件票数 Qid de votos a serem colotados</div>
              <div class="label-item">
                {{ dataObj01.exceptArrivalCnt.toLocaleString() || 0 }}
              </div>
            </div>
            <div>
              <div>实际到件票数 Qid de votos a real coletados</div>
              <div class="label-item">
                {{ dataObj01.actualArrivalCnt.toLocaleString() || 0 }}
              </div>
            </div>
            <div>
              <div>到件差异 Diferenoa na etd.de colet</div>
              <div class="label-item">
                {{ dataObj01.arrivalDiffCnt.toLocaleString() || 0 }}
              </div>
            </div>
          </div>
          <div class="flx-between">
            <div>
              <div>应发件票数 Qtd. de votos a serem coletados</div>
              <div class="label-item">
                {{ dataObj01.exceptDepartCnt.toLocaleString() || 0 }}
              </div>
            </div>
            <div>
              <div>实际发件票数 Qtd. de votos a serem coletados</div>
              <div class="label-item">
                {{ dataObj01.actualDepartCnt.toLocaleString() || 0 }}
              </div>
            </div>
            <div>
              <div>发件差异 Qtd. de votos a serem col</div>
              <div class="label-item">
                {{ dataObj01.departDiffCnt.toLocaleString() || 0 }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card class="metric-card" shadow="hover">
          <!-- 效率监控 -->
          <div class="label-title">效率监控 Monitor</div>
          <div class="flx-between" style="margin: 5px 0 10px 0">
            <div>
              <div>卸车及时率 Tempo Médio de Triagem</div>
              <div class="label-item">
                {{ ((parseFloat(dataObj02.unloadOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
              </div>
            </div>
            <div>
              <div>准时发件率 Veículos necessários esti</div>
              <div class="label-item">
                {{ ((parseFloat(dataObj02.sendOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
              </div>
            </div>
          </div>
          <div class="flx-between">
            <div>
              <div>平均分拣时长 Veículos necessários est</div>
              <div class="label-item">{{ dataObj02.avgSortTime || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 作业效率 -->
    <el-row :gutter="10">
      <el-col v-if="queryForm.dataType === 'HUB1'" :span="9">
        <el-card class="metric-card" shadow="hover">
          <!-- 班次作业效率 -->
          <ShiftOperationEfficiency ref="ShiftOperationEfficiencyRef" :params-data="dataObj06" />
        </el-card>
      </el-col>
      <el-col v-if="queryForm.dataType === 'HUB2'" :span="queryForm.dataType === 'HUB2' ? 7 : 5">
        <el-card class="metric-card" shadow="hover" style="height: 320px">
          <!-- 班次作业效率HUB2(全天) -->
          <div class="label-title">
            班次作业效率HUB2 Eficiência operacional do turno (todo o dia)
          </div>
          <div style="margin: 5px 0 10px 0">
            <div style="margin: 10px 0 45px 0">
              <div class="flx-center">分拣及时率 Eficiencia de produçao</div>
              <div class="label-itemNumber">
                {{ ((parseFloat(dataObj08.sortOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
              </div>
            </div>
            <div style="margin-bottom: 40px">
              <div class="flx-center">发货及时率 Taxa de entrega no prazo</div>
              <div class="label-itemNumber">
                {{ ((parseFloat(dataObj08.sendOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="queryForm.dataType === 'HUB2' ? 7 : 5">
        <el-card class="metric-card" shadow="hover" style="height: 320px">
          <!-- 在途与库存 -->
          <div class="label-title">在途与库存 Em trânsito com inventário</div>
          <div style="margin: 5px 0 10px 0">
            <div style="margin: 10px 0 45px 0">
              <div class="flx-center">在途票数 Veloulos necessarios est</div>
              <div class="label-itemNumber">
                {{ dataObj03.onWayWaybillCnt.toLocaleString() || 0 }}
              </div>
            </div>
            <div style="margin-bottom: 40px">
              <div class="flx-center">实时库存 Inventario em tempo real</div>
              <div class="label-itemNumber">
                {{ dataObj03.currentTimeWaybillCnt.toLocaleString() || 0 }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card class="metric-card" shadow="hover">
          <!-- 每小时效率 -->
          <HourlyEfficiency ref="HourlyEfficiencyRef" :params-data="dataObj07" />
        </el-card>
      </el-col>
    </el-row>
    <!-- 轨迹停更监控 -->
    <el-card class="metric-card" shadow="hover">
      <div class="card-header">
        <span class="label-title">轨迹停更监控 Monitoramento de interrupção de trajeto</span>
      </div>
      <div class="flx-between">
        <div>
          <div class="metric-label">停更1天 Parado há 1 dia</div>
          <div class="metric-value">{{ dataObj04.delayedOne.toLocaleString() || 0 }}</div>
        </div>
        <div>
          <div class="metric-label">停更2天 Parado há 2 dia</div>
          <div class="metric-value">{{ dataObj04.delayedTwo.toLocaleString() || 0 }}</div>
        </div>
        <div>
          <div class="metric-label">停更3天 Parado há 3 dia</div>
          <div class="metric-value">{{ dataObj04.delayedThree.toLocaleString() || 0 }}</div>
        </div>
        <div>
          <div class="metric-label">停更7天 Parado há 7 dia</div>
          <div class="metric-value">{{ dataObj04.delayedSeven.toLocaleString() || 0 }}</div>
        </div>
        <div>
          <div class="metric-label">停更15天 Parado há 15 dia</div>
          <div class="metric-value">
            {{ dataObj04.delayedFifteen.toLocaleString() || 0 }}
          </div>
        </div>
        <div>
          <div class="metric-label">停更30天 Parado há 30 dia</div>
          <div class="metric-value">{{ dataObj04.delayedThirty.toLocaleString() || 0 }}</div>
        </div>
      </div>
    </el-card>
    <!--  问题件数据监控 -->
    <el-card class="metric-card" shadow="hover">
      <div class="card-header">
        <span class="label-title">问题件数据监控 Monitoramento de dados de peças em questão</span>
      </div>
      <div v-if="queryForm.dataType === 'HUB1'" class="flx-around">
        <div>
          <div class="metric-label">总计 total</div>
          <div class="label-itemNumber">{{ problemKanban.total.toLocaleString() || 0 }}</div>
        </div>
        <div>
          <div class="metric-label">包裹被抢或被盗 Pacote roubado</div>
          <div class="label-itemNumber">
            {{ problemKanban.packageRobOrStolen.toLocaleString() || 0 }}
          </div>
        </div>
        <div>
          <div class="metric-label">包裹破损 Pacote avariado</div>
          <div class="label-itemNumber">
            {{ problemKanban.packageDamage.toLocaleString() || 0 }}
          </div>
        </div>
        <div>
          <div class="metric-label">超时未妥投 Fora do prazo contratual de entrega</div>
          <div class="label-itemNumber">
            {{ problemKanban.timeoutNotDelivered.toLocaleString() || 0 }}
          </div>
        </div>
      </div>
      <el-table
        ref="mapMain04TableRef"
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          color: '#272727',
          backgroundColor: '#efefef'
        }"
        height="280"
        style="width: 100%; margin-top: 10px"
      >
        <el-table-column
          align="center" label="序号 NO." type="index"
          width="80"
        />
        <el-table-column align="center" label="问题件原因 Motivo da Ocorrência" prop="reason">
          <template #default="scope">
            <div>{{ scope.row.reason || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="问题件数量 Quantidade de anormal" prop="problemNum">
          <template #default="scope">
            <div>{{ scope.row.problemNum.toLocaleString() || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="占比 Proporção" prop="fakeSignCount">
          <template #default="scope">
            <div>{{ scope.row.problemRate || 0 }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 编织袋回收监控  -->
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card class="metric-card" shadow="hover">
          <!-- 编织袋回收监控 -->
          <MonitoringBagRecycling ref="MonitoringBagRecyclingRef" :params-data="dataObj05" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getTransferWarehouseList } from '@/api/orderApi';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import ShiftOperationEfficiency from './components/ShiftOperationEfficiency.vue';
import HourlyEfficiency from './components/HourlyEfficiency.vue';
import MonitoringBagRecycling from './components/MonitoringBagRecycling.vue';
import { SortingDashboard } from '@/api/customer';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  name: 'EndKanbanBoard',
  components: {
    ShiftOperationEfficiency,
    HourlyEfficiency,
    MonitoringBagRecycling
  },
  data() {
    return {
      queryForm: {
        areaNameList: [],
        departmentList: [],
        stateList: [],
        dataType: 'HUB1',
        // period: 'today', // 时间段快捷选择：yesterday(昨日)/today(今日)/month(本月)/lastMonth(上月)
        dateRange: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')] // 日期范围
      },
      updateTime: dayjs().tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss'), // 页面更新时间（巴西时间）
      tableData: [],
      originalSidebarState: null, // 保存进入页面前的侧边栏状态
      regionList: [],
      stateList: [], // 州
      transferCenterList: [],
      dataObj01: {
        actualArrivalCnt: 0,
        actualDepartCnt: 0,
        arrivalDiffCnt: 0,
        departDiffCnt: 0,
        exceptArrivalCnt: 0,
        exceptDepartCnt: 0
      },
      dataObj02: {
        avgSortTime: 0,
        sendOnTimeRate: 0,
        unloadOnTimeRate: 0
      },
      dataObj03: {
        currentTimeWaybillCnt: 0,
        onWayWaybillCnt: 0
      },
      dataObj04: {
        delayedFifteen: 0,
        delayedOne: 0,
        delayedSeven: 0,
        delayedThirty: 0,
        delayedThree: 0,
        delayedTwo: 0
      },
      timeValue: [
        dayjs().format('YYYY-MM-DD'), // 开始日期：今天
        dayjs().format('YYYY-MM-DD') // 结束日期：今天
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '本周',
            onClick(picker) {
              // day.js 计算本周第一天（周一）和最后一天（周日）
              const start = dayjs().startOf('week').add(1, 'day').toDate(); // 周一
              const end = dayjs().endOf('week').add(1, 'day').toDate(); // 周日
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              // day.js 计算本月第一天和最后一天
              const start = dayjs().startOf('month').toDate();
              const end = dayjs().endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上个月',
            onClick(picker) {
              // day.js 计算上个月第一天和最后一天
              const start = dayjs().subtract(1, 'month').startOf('month').toDate();
              const end = dayjs().subtract(1, 'month').endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近3个月',
            onClick(picker) {
              // day.js 计算3个月前的今天
              const end = new Date();
              const start = dayjs().subtract(3, 'month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      paramsData: {},
      dataObj05: {},
      dataObj06: {},
      dataObj07: {},
      dataObj08: {
        sendOnTimeRate: 0,
        sortOnTimeRate: 0
      },
      problemKanban: {
        packageDamage: 0,
        packageRobOrStolen: 0,
        timeoutNotDelivered: 0,
        total: 0
      },
      allAddressOption: []
    };
  },
  async mounted() {
    // 保存进入页面前的侧边栏状态
    this.originalSidebarState = this.$store.state.app.sidebar.opened;
    // 关闭侧边栏（无动画）
    this.$store.dispatch('app/closeSideBar', { withoutAnimation: true });
    this.getSearch();
    this.getRegionStateSite();
  },
  beforeDestroy() {
    // 离开页面时，如果原本侧边栏是展开的，则恢复展开状态
    if (this.originalSidebarState) {
      this.$store.dispatch('app/toggleSideBar');
    }
  },
  methods: {
    changeDataType() {
      this.getSearch();
    },
    getSearch() {
      this.getSortingDashboardArrivalDepart('arrivalDepartMonitor');
      this.getSortingDashboardArrivalDepart('efficiencyMonitor');
      this.getSortingDashboardArrivalDepart('onWayStock');
      this.getSortingDashboardArrivalDepart('trackSuspendMonitor');
      this.getSortingDashboardArrivalDepart('problemMonitor');
      this.getSortingDashboardArrivalDepart('bagRecycleMonitor');
      this.getSortingDashboardArrivalDepart('eachWorkEfficiency');
      this.getSortingDashboardArrivalDepart('perHourEfficiency');
      this.getSortingDashboardArrivalDepart('eachWorkEfficiencyHUB2');
      this.getSortingDashboardArrivalDepart('updateTime');
    },
    // 分拣中心到发件数据监控
    getSortingDashboardArrivalDepart(chartType) {
      const data = {
        pageNumber: 1,
        pageSize: 10,
        dashboardType: 'SORTING_DASHBOARD',
        chartType: chartType,
        params: {}
      };
      data.params = this.queryParam();
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.startDate = dayjs(this.timeValue[0]).format('YYYY-MM-DD');
        data.params.endDate = dayjs(this.timeValue[1]).format('YYYY-MM-DD');
      } else {
        this.$message.error('请选择时间范围');
        return;
      }
      this.paramsData = data;
      SortingDashboard(data).then((res) => {
        if (res.code === 200) {
          console.log(res, 'SortingDashboard');
          if (chartType === 'arrivalDepartMonitor') {
            if (res.data.chartData) {
              this.dataObj01 = res.data.chartData;
            }
          }
          if (chartType === 'efficiencyMonitor') {
            if (res.data.chartData) {
              this.dataObj02 = res.data.chartData;
            }
          }
          if (chartType === 'onWayStock') {
            if (res.data.chartData) {
              this.dataObj03 = res.data.chartData;
            }
          }
          if (chartType === 'trackSuspendMonitor') {
            if (res.data.chartData) {
              this.dataObj04 = res.data.chartData;
            }
          }
          if (chartType === 'problemMonitor') {
            if (res.data.chartData) {
              this.tableData = res.data.chartData.dataList || [];
              const handledData = this.tableData.map((item) => ({
                ...item,
                problemRate:
                  !item.problemRate || isNaN(parseFloat(item.problemRate))
                    ? '0.00%'
                    : (parseFloat(item.problemRate) * 100).toFixed(2) + '%'
              }));
              this.tableData = handledData;
              this.problemKanban.packageDamage = res.data.chartData.packageDamage;
              this.problemKanban.packageRobOrStolen = res.data.chartData.packageRobOrStolen;
              this.problemKanban.timeoutNotDelivered = res.data.chartData.timeoutNotDelivered;
              this.problemKanban.total = res.data.chartData.total;
            }
          }
          if (chartType === 'bagRecycleMonitor') {
            if (res.data.chartData) {
              this.dataObj05 = res.data;
              this.dataObj05.dataType = this.queryForm.dataType;
            }
          }
          // 作业
          if (chartType === 'eachWorkEfficiency') {
            if (res.data.chartData) {
              this.dataObj06 = res.data;
            }
          }
          // 每小时
          if (chartType === 'perHourEfficiency') {
            if (res.data.chartData) {
              this.dataObj07 = res.data;
            }
          }
          // 班次hub 2
          if (chartType === 'eachWorkEfficiencyHUB2') {
            if (res.data.chartData) {
              this.dataObj08 = res.data.chartData;
            }
          }
          if (chartType === 'updateTime') {
            if (res.data.chartData) {
              this.updateTime = res.data.chartData;
            }
          }
        }
      });
    },
    // 查询条件整理
    queryParam() {
      const params = {
        areaNameList: this.queryForm.areaNameList,
        departmentList: this.queryForm.departmentList,
        stateList: this.queryForm.stateList,
        dataType: this.queryForm.dataType,
        // period: this.queryForm.period,
        startDate: '',
        endDate: ''
      };
      return params;
    },
    // 加change函数监控州、网点
    changeRegion() {
      this.queryForm.stateList = [];
      this.stateList = [];
      this.transferCenterList = [];
      if (this.queryForm.areaNameList.length === 0) {
        this.transferCenterList = this.allAddressOption;
        // 过滤掉state相同数据获取州选项
        const stateOption = new Set();
        this.stateList = this.allAddressOption.filter((item) => {
          if (stateOption.has(item.state)) {
            return false;
          }
          stateOption.add(item.state);
          return true;
        });
      } else {
        // 只根据 areaNameList 过滤
        this.transferCenterList = this.allAddressOption.filter((item) =>
          this.queryForm.areaNameList.includes(item.regionName)
        );
        const stateOption = new Set();
        this.stateList = this.transferCenterList.filter((item) => {
          if (stateOption.has(item.state)) {
            return false;
          }
          stateOption.add(item.state);
          return true;
        });
      }
    },
    // 州选项变化
    changeStateList() {
      this.transferCenterList = [];
      this.queryForm.departmentList = [];
      // 如果 areaNameList 为空，则只根据 stateList 过滤
      if (this.queryForm.areaNameList.length === 0) {
        if (this.queryForm.stateList.length === 0) {
          // 如果两个数组都为空，显示所有数据
          this.transferCenterList = this.allAddressOption; // 需要先保存完整数据
        } else {
          // 只根据 stateList 过滤
          this.transferCenterList = this.allAddressOption.filter((item) =>
            this.queryForm.stateList.includes(item.state)
          );
        }
      } else {
        if (this.queryForm.stateList.length === 0) {
          // 只根据 areaNameList 过滤
          this.transferCenterList = this.allAddressOption.filter((item) =>
            this.queryForm.areaNameList.includes(item.regionName)
          );
        } else {
          // 同时根据 areaNameList 和 stateList 过滤
          this.transferCenterList = this.allAddressOption.filter(
            (item) =>
              this.queryForm.areaNameList.includes(item.regionName) &&
              this.queryForm.stateList.includes(item.state)
          );
        }
      }
    },
    // 初始获取所有的大区，州，站点
    getRegionStateSite() {
      const param = {
        areaNameList: [],
        stateList: []
      };
      getTransferWarehouseList(param).then((res) => {
        if (res.code === 200) {
          this.allAddressOption = res.data;
          // 过滤掉regionId相同的数据获取大区选项
          const regionOption = new Set();
          this.regionList = this.allAddressOption.filter((item) => {
            if (regionOption.has(item.regionId)) {
              return false;
            }
            regionOption.add(item.regionId);
            return true;
          });
          // 过滤掉state相同数据获取州选项
          const stateOption = new Set();
          this.stateList = this.allAddressOption.filter((item) => {
            if (stateOption.has(item.state)) {
              return false;
            }
            stateOption.add(item.state);
            return true;
          });
          this.transferCenterList = this.allAddressOption;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.end-kanban-board {
  padding: 10px;
  background-color: #f0f2f5;
  min-height: 100vh;
}

.label-title {
  font-weight: bold;
  font-size: 16px;
  color: #0f172a;
}

.label-item {
  text-align: center;
  color: #00A551;
  font-weight: bold;
}

.label-itemNumber {
  text-align: center;
  color: #fd9f18;
  font-weight: bold;
  font-size: 24px;
  margin-top: 5px;
}

.metric-card {
  margin-bottom: 10px;
  border: none;
  background: #ffffff;
  border-radius: 12px;

  ::v-deep .el-card__header {
    border-bottom: none;
    padding-bottom: 0;
  }

  ::v-deep .el-card__body {
    padding: 10px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #0f1728;
  }

  .metric-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: #f9f9f9;
    padding: 20px 0px 16px 10px;
    margin-bottom: 24px;
    border-radius: 12px;
    overflow: hidden;
  }

  .metric-corner {
    position: absolute;
    top: 0;
    right: 0;
    width: 92px;
    height: 52px;
    border-radius: 0 12px 0 100%;
  }
}

.metric-row {
  text-align: center;
}

.metric-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.metric-label {
  font-size: 16px;
  margin-bottom: 10px;
  margin-top: 5px;
}

.metric-value {
  font-size: 24px;
  font-weight: 600;
  color: #20c997; /* 浅色系青绿色，适配白天模式 */
}
</style>
